import React from 'react';
import {
  AppBar,
  Box,
  Button,
  Grid,
  TextField,
  Toolbar,
  Typography,
  Tooltip,
  TablePagination,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../../Utils/routes.json';

import { useEffect, useState } from 'react';
import KenCard from '../../../../global_components/KenCard';

import KenDialogBox from '../../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../../global_components/KenSelect';
import { RiFilterLine } from 'react-icons/ri';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import {
  getStudentStatusData,
  postStudentStatusData,
  getExamModuleListData,
  getStudentStatusWithoutParaData,
} from '../../../../Utils/apiServices';

// test
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
// Icons
import EditIcon from '@material-ui/icons/EditOutlined';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';

import '../../../../style/index.css';
import KenGridEditableData from '../../../../global_components/kenEditDataGrid/KenGridEcditableForStudentStatus';
import KenInputField from '../../../../global_components/KenInputField/kenInputField2';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { sendMailStudentStatus } from '../../../../Utils/sendMail';
import KenLoader from '../../../../Components/KenLoader';
import TablePaginationActions from '../../../../global_components/KenGrid/TablePaginationActions';

const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'STUDENT STATUS',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  modalHeader: {
    fontWeight: 'normal',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    '& p': {
      marginRight: '25px',
    },
  },
  addButton: {
    color: 'white',
    marginRight: '10px',
    backgroundColor: '#272727',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    height: '28px',
    width: '78px',
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    background: 'orange',
    borderRadius: '40px',
    fontSize: '10px',
    margin: '5px  5px',
    color: 'white',
    width: '101px',
    height: '25px',

    '&:hover': {
      color: 'white',
      background: 'orange',
    },
    // color: '#FFFFFF',
    // background: '#EB5757',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  normal: {
    color: 'white',
    background: 'green',
    borderRadius: '20px',
    fontSize: '10px',
    margin: '5px 5px',
    '&:hover': {
      background: 'green',
      color: 'white',
    },
  },
  // normal: {
  //   color: 'white',
  //   background: 'green',
  //   borderRadius: '40px',
  //   fontSize: '10px',
  //   width: '101px',
  //   margin: '5px 5px',
  //   height: '25px',
  //   '&:hover': {
  //     background: 'green',
  //     color: 'white',
  //   },
  //   // color: '#FFFFFF',
  //   // background: '#27AE60',
  //   // borderRadius: 15,
  //   // fontSize: '10px',
  //   // fontWeight: 'bold',
  //   // margin: '0 5px',
  //   // width: '102px',
  // },
  medium: {
    color: '#f17100',
    background: '#55b0cd',
    borderRadius: '40px',
    fontSize: '10px',
    margin: '5px 5px',
    width: '101px',
    height: '25px',

    '&:hover': {
      background: '#55b0cd',
      color: '#f17100',
    },
    // color: '#FFFFFF',
    // background: '#F2994A',
    // width: '102px',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  searchRoot: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    border: '1px solid #19228d',
  },
  publishGenerate: {
    color: '#505F79',
    background: 'rgba(196, 196, 196,0.2)',
    borderRadius: '20px',
    fontSize: '10px',
    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(196, 196, 196,0.2)',
      color: '#505F79',
    },
  },
}));

const selectOptionsCampus = [
  {
    label: 'Select Campus',
    value: '',
  },
  {
    label: 'Mumbai',
    value: 'Mumbai',
  },
  {
    label: 'Pune',
    value: 'Pune',
  },
];

const selectOptionsSubject = [
  {
    label: 'Select Program',
    value: '',
  },
  {
    label: 'BBAECO103-Macroeconomics',
    value: 'BBAECO103-Macroeconomics',
  },
];

const selectOptionsReason = [
  {
    label: 'Select Campus',
    value: '',
  },
  {
    label: 'Eligible',
    value: 'Eligible',
  },
  {
    label: 'Not Eligible',
    value: 'Not eligible',
  },
  {
    label: 'At Risk',
    value: 'At Risk',
  },
  {
    label: 'Under Review',
    value: 'Under Review',
  },
];

const UserCellBulkMessage = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const StudentStatus = (props) => {
  const { variant } = props;
  const { t } = useTranslation();

  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const [selectValueCampus, setSelectValueCampus] = useState(
    selectOptionsCampus[0].value
  );
  const [selectValue, setSelectValue] = useState('');
  const handleSelectChangeCampus = (e) => {
    setSelectValueCampus(e.target.value);
    setSelectValueSubject('');
  };

  const [selectValueCampus1, setSelectValueCampus1] = useState('');
  const handleSelectChangeCampus1 = (e) => {
    setSelectValueCampus1(e.target.value);
  };

  const [selectValueProgram, setSelectValueProgram] = useState('');
  const handleSelectChangePrograms = (e) => {
    setSelectValueProgram(e.target.value);
    setSelectValueCampus('');
    setSelectValueSubject('');
  };

  const [selectValueSubject, setSelectValueSubject] = useState(
    selectOptionsSubject[0].value
  );
  const handleSelectChangeProgram = (e) => {
    setSelectValueSubject(e.target.value);
  };

  const [selectValueReason, setSelectValueReason] = useState(
    selectOptionsReason[0].value
  );
  const handleSelectChangeReason = (e) => {
    setSelectValueReason(e.target.value);
  };

  const [selectReason, setSelectReasonTerm] = useState('');
  const handleSelectChangeRes = (e) => {
    setSelectReasonTerm(e.target.value);
  };

  const [selectNameOrRollNum, setselectNameOrRollNum] = useState('');

  const handleSelectChangeNameOrRoll = (e) => {
    setselectNameOrRollNum(e.target.value);
  };
  const [selectValueBatch1, setSelectValueBatch1] = useState([]);

  const [selectValueBatch, setSelectValueBatch] = useState('');
  const handleSelectChangeBatch = (e) => {
    setSelectValueBatch(e.target.value);
  };
  const [selectValueExamCycle1, setSelectValueExamCycle1] = useState([]);

  const [selectValueExamCycle, setSelectValueExamCycle] = useState('');
  const handleSelectChangeExamCycle = (e) => {
    setSelectValueExamCycle(e.target.value);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const [filterDialog, setFilterDialog] = useState(false);

  function handleFilterDialog() {
    setFilterDialog((prevState) => !prevState);
  }

  const [sendBulkMessageDialog, setSendBulkMessageDialog] = useState(false);

  function handleSendBulkMessageDialog() {
    setSendBulkMessageDialog((prevState) => !prevState);
  }
  const sendBulkMail = () => {
    sendMailStudentStatus();
    setSendBulkMessageDialog((prevState) => !prevState);
  };
  const attachFileMail = () => {
    console.log('hello world');
  };

  const [selectAllData, setSelectAllData] = useState(false);

  const selectOptionsAllocated = [
    {
      label: 'Eligible',
      value: 'Eligible',
    },
    {
      label: 'Not Eligible',
      value: 'Not eligible',
    },
    {
      label: 'At Risk',
      value: 'At Risk',
    },
    {
      label: 'Under Review',
      value: 'Under Review',
    },
  ];

  // Editing

  const [studentStatusData, setStudentStatusData] = useState([]);
  const [messageDialog, setMessageDialog] = useState(false);
  const [loading, setLoading] = React.useState(false);

  // For Filter
  const [filterData, setFilterData] = useState();

  const [examMonthData, setExamMonthData] = useState([]);
  const [selectCourseData, setselectCourseData] = useState([]);
  const [selectTermData, setselectTermData] = useState([]);
  const [selectCampusData, setselectCampusData] = useState([]);
  const [selectProgramData, setselectProgramData] = useState([]);

  const [totalData, setTotalData] = useState(25);

  // Pagination
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [previous, setPrevious] = useState({});
  const [searchBar, setsearchBar] = useState(false);

  const onToggleEditMode = (id) => {
    setStudentStatusData((state) => {
      return studentStatusData?.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const saveData = () => {
    setLoading(true);

    console.log('object');
    const newData = [...studentStatusData];

    const payload = newData.map((row) => {
      return {
        Id: row.id,
        reason: row.reason,
        eligibilityStatus: row.eligibility_status,
        rollNumber: row.id_no,
        sendEmail: false,
      };
    });
    setLoading(true);

    postStudentStatusData(payload)
      .then((res) => {
        setLoading(true);
        toast.success(`${res.message}`);
        getStudentData();
      })
      .catch((err) => {
        setLoading(true);
        toast.error(`${err}`);

        alert('Failed to add. Please try again.');
      });
    setLoading(true);
  };

  const onChange = (e, row) => {
    console.log('erow', e, row);
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = studentStatusData?.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setStudentStatusData(newRows);
  };

  const onToggleEdit = (id, rowes) => {
    setStudentStatusData((state) => {
      return studentStatusData?.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  // const onRevert = (id) => {
  //   const newRows = studentStatusData?.map((row) => {
  //     if (row.id === id) {
  //       return previous[id] ? previous[id] : row;
  //     }
  //     return row;
  //   });
  //   setStudentStatusData(newRows);
  //   setPrevious((state) => {
  //     delete state[id];
  //     return state;
  //   });
  //   onToggleEdit(id, newRows);
  // };

  const onRevert = (id) => {
    const newRows = studentStatusData.map((row) => {
      if (row.id === id) {
        return previous[id] ? previous[id] : row;
      }
      return row;
    });
    setStudentStatusData(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleEdit(id, newRows);
  };

  useEffect(() => {
    getExamModuleListData().then((res) => {
      console.log('resresresresresresres', res);
      setFilterData(res);
    });
  }, []);

  useEffect(() => {
    let TermListData = filterData?.TermList?.map((item) => {
      return {
        label: item?.TermName,
        value: item?.TermName,
      };
    });
    setselectTermData(TermListData);

    // For Course
    let CourseListData = filterData?.CourseList?.filter((item) => {
      return (
        selectValueCampus == item?.TermName &&
        item?.TermName &&
        item?.CourseName
      );
    }).map((item) => {
      return {
        label: item?.CourseName,
        value: item?.CourseName,
      };
    });

    setselectCourseData(CourseListData);

    let CampusListData = filterData?.campus.map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    setselectCampusData(CampusListData);

    let BatchListData = filterData?.batchList
      .filter((item) => {
        return item != null;
      })
      .map((item) => {
        return {
          label: item,
          value: item,
        };
      });

    setSelectValueBatch1(BatchListData);

    let ProgramListData = filterData?.ProgrameList.filter((item) => {
      return item?.ProgrameName != null;
    }).map((item) => {
      return {
        label: item?.ProgrameName,
        value: item?.ProgrameName,
      };
    });

    setselectProgramData(ProgramListData);

    let ExamCycleListData = filterData?.ExamMonthList.filter((item) => {
      return item != null;
    }).map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    setSelectValueExamCycle1(ExamCycleListData);
    // let CampusListData = filterData?.campus.map((item) => {
    //   return {
    //     label: item,
    //     value: item,
    //   };
    // });
    // setselectCampusData(CampusListData);
  }, [filterData, selectValueCampus]);

  const getStudentData = () => {
    setLoading(true);
    let filterData = {
      campus: selectValueCampus1,
      course: selectValueSubject,
      eligibilityStatus: selectValueReason,
      reason: selectReason,
      filter: selectValue,
      nameOrRollNum: selectNameOrRollNum,
      batch: selectValueBatch,
      examCycle: selectValueExamCycle,
      pageNo: page,
      count: rowsPerPage,
      Programe: selectValueProgram,
    };
    getStudentStatusData(filterData).then((res) => {
      const studentInfo =
        res?.studentsList === null
          ? []
          : res?.studentsList.map((item, index) => {
              return {
                id: item?.Id,
                name: item?.name ? item?.name : 'N/A',
                id_no: item?.rollNumber ? item?.rollNumber : 'N/A',
                campus: item?.campusName ? item?.campusName : 'N/A',
                course: item?.courseName ? item?.courseName : 'N/A',
                eligibility_status: item?.eligibilityStatus
                  ? item?.eligibilityStatus
                  : 'N/A',
                reason: item?.reason ? item?.reason : 'N/A',
                batch: item?.batch ? item?.batch : '',
                examCycle: item?.examCycle ? item?.examCycle : '',
                term: item?.Term ? item?.Term : '',
                Programe: item?.Programe ? item?.Programe : '',
              };
            });
      setLoading(false);
      setTotalData(res.noOfRecords);
      setStudentStatusData(studentInfo);
      setselectNameOrRollNum('');

      setFilterDialog(false);
    });
  };

  const ResetData = () => {
    // window.location.reload();
    setLoading(true);
    setselectNameOrRollNum('');
    let filterData = {
      campus: '',
      course: '',
      eligibilityStatus: '',
      reason: '',
      filter: '',
      nameOrRollNum: '',
      batch: '',
      examCycle: '',
      Programe: '',
      pageNo: 0,
      count: 25,
    };
    getStudentStatusData(filterData).then((res) => {
      const studentInfo =
        res?.studentsList === null
          ? []
          : res?.studentsList.map((item, index) => {
              return {
                id: item?.Id,
                name: item?.name ? item?.name : 'N/A',
                id_no: item?.rollNumber ? item?.rollNumber : 'N/A',
                campus: item?.campusName ? item?.campusName : 'N/A',
                course: item?.courseName ? item?.courseName : 'N/A',
                eligibility_status: item?.eligibilityStatus
                  ? item?.eligibilityStatus
                  : 'N/A',
                reason: item?.reason ? item?.reason : 'N/A',
                batch: item?.batch ? item?.batch : '',
                examCycle: item?.examCycle ? item?.examCycle : '',
                term: item?.Term ? item?.Term : '',
                Programe: item?.Programe ? item?.Programe : '',
              };
            });
      setLoading(false);
      setTotalData(res.noOfRecords);
      setStudentStatusData(studentInfo);
      setsearchBar(false);

      setFilterDialog(false);
    });
  };

  const resetDefualtFilterKeys = (key) => {
    if (key === 'Campus') {
      setSelectValueCampus1('');
    }
  };

  useEffect(() => {
    // ResetData();
    getStudentData();
    // termListss();
  }, [page, rowsPerPage]);

  return (
    <Box>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {loading && <KenLoader />}

      <Box className={classes.breadCrumbWrapper}>
        <BreadCrumb array={arrayBreadCrumb} history={history} />
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Student Status
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              startIcon={<RiFilterLine />}
              variant="contained"
              // style={{
              //   marginRight: '15px',
              //   height: '28px',
              //   width: '78px',
              //   color: 'white',
              // }}
              className={classes.addButton}
              onClick={handleFilterDialog}
            >
              Filter
            </Button>
            <Button
              variant="contained"
              className={classes.addButton}
              // style={{
              //   marginRight: '15px',
              //   color: 'white',
              //   fontWeight: 'bold',
              //   height: '28px',
              //   width: '78px',
              //   textDecoration: 'none',
              //   textTransform: 'none',
              // }}
              onClick={() => saveData()}
            >
              Save
            </Button>
            <Button
              variant="contained"
              className={classes.addButton}
              // style={{
              //   marginRight: '15px',
              //   color: 'white',
              //   fontWeight: 'bold',
              //   height: '28px',
              //   width: '78px',
              //   textDecoration: 'none',
              //   textTransform: 'none',
              // }}
              onClick={() => {
                setsearchBar((prev) => !prev);
              }}
            >
              Search
            </Button>
          </Grid>
        </Toolbar>
      </AppBar>
      <AppBar position="static" elevation={0} className={classes.header}>
        {searchBar && (
          <Box>
            <Paper className={classes.searchRoot}>
              <InputBase
                className={classes.input}
                placeholder="Search By RollNumber Or Name"
                inputProps={selectNameOrRollNum ? selectNameOrRollNum : ''}
                onChange={handleSelectChangeNameOrRoll}

                // value={selectNameOrRollNum}
              />
              {/* <KenInputField
                className={classes.input}
                value={selectNameOrRollNum}
                dropdownColor="#FFFFFF"
                onChange={handleSelectChangeNameOrRoll}
                required
              /> */}
              <IconButton
                type="submit"
                className={classes.iconButton}
                aria-label="search"
                onClick={() => getStudentData()}
              >
                <SearchIcon />
              </IconButton>
              <IconButton
                type="submit"
                className={classes.iconButton}
                aria-label="search"
                onClick={() => {
                  ResetData();
                }}
              >
                <RotateLeftIcon />
              </IconButton>
              {/* <Button
                variant="contained"
                color="primary"
                className={classes.addButton}
                style={{
                  marginRight: '15px',
                  background: '#979797',
                  color: 'white',
                  fontWeight: 'bold',
                  textDecoration: 'none',
                  textTransform: 'none',
                }}
                onClick={() => {
                  ResetData();
                }}
              >
                Reset{' '}
              </Button> */}
            </Paper>
          </Box>
        )}
      </AppBar>

      <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <Table className={classes.table} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell className="tableHeaderTitle" align="left">
                  NAME
                </TableCell>
                <TableCell
                  className="tableHeaderTitle"
                  align="left"
                  style={{ background: '#FFFFFF' }}
                >
                  ID NO.
                </TableCell>{' '}
                <TableCell className="tableHeaderTitle" align="left">
                  EXAM CYCLE
                </TableCell>{' '}
                <TableCell className="tableHeaderTitle" align="left">
                  PROGRAM
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  BATCH
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  CAMPUS
                </TableCell>{' '}
                <TableCell className="tableHeaderTitle" align="left">
                  TERM
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  COURSE
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  ELIGIBILITY STATUS{' '}
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  REASON
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  EDIT
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {console.log(
                'studentStatusDatastudentStatusData',
                studentStatusData
              )}
              {studentStatusData?.length === 0 ? (
                <TableCell colSpan={8}>
                  <Typography style={{ textAlign: 'center', color: 'red' }}>
                    No Data found{' '}
                  </Typography>

                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.addButton}
                    style={{
                      marginRight: '15px',
                      background: '#979797',
                      color: 'white',
                      fontWeight: 'bold',
                      textDecoration: 'none',
                      textTransform: 'none',
                      marginLeft: '46%',
                      marginTop: '20px',
                    }}
                    onClick={() => {
                      ResetData();
                    }}
                  >
                    All Data
                  </Button>
                </TableCell>
              ) : (
                studentStatusData?.map((row) => (
                  <TableRow
                    className="editableTableRowData editableTableRowDatas"
                    key={row.id}
                  >
                    {/* <CustomTableCell {...{ row, name: 'name', onChange }} /> */}
                    <KenGridEditableData
                      {...{
                        row,
                        onChange,
                        columns: [
                          {
                            column_name: 'name',
                            is_inline_edit: false,
                            inline_edit_type: '',
                            label: 'name',
                          },
                          {
                            column_name: 'id_no',
                            is_inline_edit: false,
                            inline_edit_type: '',
                            label: 'id_no',
                          },

                          {
                            column_name: 'examCycle',
                            is_inline_edit: false,
                            inline_edit_type: '',
                            label: 'examCycle',
                          },
                          {
                            column_name: 'Programe',
                            is_inline_edit: false,
                            inline_edit_type: '',
                            label: 'Programe',
                          },
                          {
                            column_name: 'batch',
                            is_inline_edit: false,
                            inline_edit_type: '',
                            label: 'batch',
                          },
                          {
                            column_name: 'campus',
                            is_inline_edit: false,
                            inline_edit_type: '',
                            label: 'campus',
                          },
                          {
                            column_name: 'term',
                            is_inline_edit: false,
                            inline_edit_type: '',
                            label: 'term',
                          },
                          {
                            column_name: 'course',
                            is_inline_edit: true,
                            inline_edit_type: '',
                            label: 'course',
                          },
                          {
                            column_name: 'eligibility_status',
                            is_inline_edit: true,
                            inline_edit_type: 'kenSelect',
                            dropdown: selectOptionsAllocated,
                            // label: 'eligibility_status',
                            // style: 'red',
                          },

                          {
                            column_name: 'reason',
                            is_inline_edit: true,
                            inline_edit_type: 'kenInput',
                            // dropdown: selectOptionsAllocated,
                            // label: 'reason',
                          },
                        ],
                      }}
                    />

                    <TableCell className={classes.selectTableCell}>
                      {row.isEditMode ? (
                        <>
                          <IconButton
                            aria-label="done"
                            onClick={() => onToggleEditMode(row.id)}
                          >
                            <DoneIcon />
                          </IconButton>
                          <IconButton
                            aria-label="revert"
                            onClick={() => onRevert(row.id)}
                          >
                            <RevertIcon />
                          </IconButton>
                        </>
                      ) : (
                        <IconButton
                          aria-label="delete"
                          onClick={() => onToggleEditMode(row.id)}
                        >
                          <EditIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}{' '}
            </TableBody>{' '}
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              colSpan={10}
              count={totalData ? totalData : studentStatusData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Table>
        </KenCard>
      </Box>

      {/* Filter Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            EXAM FILTER
          </Typography>
        }
        open={filterDialog}
        handleClose={() => handleFilterDialog()}
        negativeButtonClick={() => handleFilterDialog()}
        positiveButtonClick={() => getStudentData()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Program"
              options={selectProgramData}
              value={selectValueProgram}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangePrograms}
              required
            />{' '}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid
              container
              spacing={1}
              // style={{ border: '1px solid gray', borderRadius: '10px' }}
            >
              <Grid item xs={12} sm={11}>
                <KenSelectWrap
                  label="Campus"
                  options={selectCampusData}
                  value={selectValueCampus1}
                  dropdownColor="#FFFFFF"
                  onChange={handleSelectChangeCampus1}
                  required
                />{' '}
              </Grid>
              {/* <Grid item xs={12} sm={1}>
                <IconButton
                  // type="submit"
                  className={classes.iconButton}
                  aria-label="search"
                  onClick={() => {
                    resetDefualtFilterKeys('Campus');
                  }}
                >
                  <RotateLeftIcon />
                </IconButton>
              </Grid> */}
            </Grid>
            {/*             
            <KenSelectWrap
              label="Campus"
              options={selectCampusData}
              value={selectValueCampus1}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeCampus1}
              required
            />{' '}
            <IconButton
              // type="submit"
              className={classes.iconButton}
              aria-label="search"
              onClick={() => {
                ResetDatassss();
              }}
            >
              <RotateLeftIcon />
            </IconButton> */}
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Term"
              options={selectTermData}
              value={selectValueCampus}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeCampus}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenInputField
              label="Reason"
              value={selectReason}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeRes}
              className="abssssssssss"
              required
            />{' '}
            {/* <KenSelectWrap
              label="Reason"
              options={selectOptionsReason}
              value={selectValueReason}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeReason}
              required
            /> */}
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Course"
              options={selectCourseData}
              value={selectValueSubject}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeProgram}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Eligibility Status"
              options={selectOptionsReason}
              value={selectValueReason}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeReason}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Batch"
              options={selectValueBatch1}
              value={selectValueBatch}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeBatch}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Exam Cycle"
              options={selectValueExamCycle1}
              value={selectValueExamCycle}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeExamCycle}
              required
            />
          </Grid>
        </Grid>
      </KenDialogBox>
    </Box>
  );
};

export default StudentStatus;
